export const ACTIVITY_TYPE_IDS = {
  grill: '2',
  canopy: '3',
};

export const ADDITIONAL_SERVICE_ACTIVITY_TYPE_IDS: string[] = [
  ACTIVITY_TYPE_IDS.grill,
  ACTIVITY_TYPE_IDS.canopy,
];
